const MODIFIER_REF_REGISTRY: Record<string, string | null> = {
    'user-': 'user',
    'transaction-': 'transaction',
    'stock-transfer-': 'stock-transfer',
    'supply-order-': 'supply-order',
    'delivery-': 'delivery',
    'order-': 'order',
    'warehouse-delivery-': 'warehouse-delivery',
    'warehouse-return-': 'warehouse-return',
    'site-setup-': 'site-setup',
    'bundle-': 'bundle',
    'box-': null,
    'cron-job-': null,
    'order-prediction-': null,
    'stock-transfer-prediction-': null,
};

const SORTED_PREFIXES = Object.keys(MODIFIER_REF_REGISTRY).sort((a, b) => b.length - a.length);

export const getModifierLink = (ref: string): { pathRoot: string; _id: string } | null => {
    if (!ref) return null;
    if (ref.endsWith('-aborted')) return null;

    const cleaned = ref.endsWith('-manually-prepared') ? ref.slice(0, -'-manually-prepared'.length) : ref;

    const prefix = SORTED_PREFIXES.find((p) => cleaned.startsWith(p));
    if (!prefix) return null;

    const pathRoot = MODIFIER_REF_REGISTRY[prefix];
    if (!pathRoot) return null;

    return { pathRoot, _id: cleaned.slice(prefix.length) };
};
